import { render, staticRenderFns } from "./CombinationsProductsControls.vue?vue&type=template&id=69223262"
import script from "./CombinationsProductsControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductsControls.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports